"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowOnlyLettersAndNumbers = exports.NonEmptyStringRegex = exports.PhoneRegex = exports.EmailRegex = void 0;
exports.EmailRegex = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;
exports.PhoneRegex = /^05\d{8}$/;
exports.NonEmptyStringRegex = /^.+$/;
exports.AllowOnlyLettersAndNumbers = /[^a-zA-Z0-9\u0590-\u05FF\s]/;
